import { USER_INTERACTION } from '../constants';
var INTERACTIVE_SELECTOR = 'a[data-transaction-name], button[data-transaction-name]';
export function observePageClicks(transactionService) {
  var clickHandler = function clickHandler(event) {
    if (event.target instanceof Element) {
      createUserInteractionTransaction(transactionService, event.target);
    }
  };
  var eventName = 'click';
  var useCapture = true;
  window.addEventListener(eventName, clickHandler, useCapture);
  return function () {
    window.removeEventListener(eventName, clickHandler, useCapture);
  };
}
function createUserInteractionTransaction(transactionService, target) {
  var _getTransactionMetada = getTransactionMetadata(target),
    transactionName = _getTransactionMetada.transactionName,
    context = _getTransactionMetada.context;
  var tr = transactionService.startTransaction("Click - " + transactionName, USER_INTERACTION, {
    managed: true,
    canReuse: true,
    reuseThreshold: 300
  });
  if (tr && context) {
    tr.addContext(context);
  }
}
function getTransactionMetadata(target) {
  var metadata = {
    transactionName: null,
    context: null
  };
  metadata.transactionName = buildTransactionName(target);
  var classes = target.getAttribute('class');
  if (classes) {
    metadata.context = {
      custom: {
        classes: classes
      }
    };
  }
  return metadata;
}
function buildTransactionName(target) {
  var dtName = findCustomTransactionName(target);
  if (dtName) {
    return dtName;
  }
  var tagName = target.tagName.toLowerCase();
  var name = target.getAttribute('name');
  if (!!name) {
    return tagName + "[\"" + name + "\"]";
  }
  return tagName;
}
function findCustomTransactionName(target) {
  var trCustomNameAttribute = 'data-transaction-name';
  var fallbackName = target.getAttribute(trCustomNameAttribute);
  if (target.closest) {
    var element = target.closest(INTERACTIVE_SELECTOR);
    return element ? element.getAttribute(trCustomNameAttribute) : fallbackName;
  }
  return fallbackName;
}